import React, { Component } from 'react';
import titleCase from '../../utils/toTitleCase';
import moment from 'moment';
import numeral from 'numeral';
import {withRouter} from "react-router-dom";
import styles from '../../style/style';

class HouseCard extends Component {
  constructor(props) {
    super(props);
  }

  fetchHouse = () => {
    this.props.history.push(
      {
        pathname: `/stats/${this.props.coords[1]}/${this.props.coords[0]}/house`,
        search: `?address=${this.props.formatted_address}`
      }
    );
  }

  render() {
    return (
        <div style={{
          color: "black",
          boxShadow: "hsla(240, 100%, 50%, 0.2) 1px 1px 8px 2px",
          margin: "0 0.75rem 1rem",
          borderRadius: "8px",
          minHeight: "300px",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
          background: "#fff"
        }}
        >
            <span style={{
              background: "red",
              color: "#fff",
              fontSize: "12px",
              borderRadius: "4px",
              position: "absolute",
              top: "1rem",
              padding: "0.25rem 0.5rem",
              left: "1rem",
              fontWeight: "600",
              letterSpacing: "1px"
            }}>€{ numeral(this.props.price).format('(0[.]0a)') }</span>
          <div style={{ height: "180px", width: "100%", backgroundSize: "cover", backgroundImage: `url(${`https://maps.googleapis.com/maps/api/streetview?size=400x180&location=${this.props.coords[1]},${this.props.coords[0]}&key=AIzaSyDcW3Ft4EBrqo54_qhvPrd1oh3bQgS5Vt8`})` }}></div>
          <div style={{ padding: "0 1rem 1rem", display: "flex", flexDirection: "column", justifyContent: "space-between", flex: 1 }}>
            <p style={{ fontSize: "14px", marginBottom: 0 }}>{ titleCase(this.props.input_string) }</p>
            <div>
              <button style={{
                ...styles.lightButton,
                background: "aliceblue",
                color: "blue"
              }}
              onClick={this.fetchHouse}>
                View address
              </button>
              <p style={{ fontSize: "12px", color: "#666", marginBottom: 0  }}>{ (this.props.distance && this.props.distance > 0) ? `${this.props.distance.toFixed(1)}km away · ` : ``}Sold { moment(this.props.date, "DD/MM/YYYY").fromNow()}</p>
            </div>
          </div>
        </div>
      );
  }
}

export default withRouter(HouseCard);


// WEBPACK FOOTER //
// ./src/components/house-card/index.js